import React from 'react';

/**
 * Component to display user information
 */
const UserInfo = ({ formData }) => {
  if (!formData) return null;
  
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold mb-2">Your Information</h3>
      
      <div className="bg-gray-50 p-4 rounded border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <div>
            <p className="text-gray-700">
              <span className="font-medium">Name:</span> {formData.name}
            </p>
          </div>
          
          <div>
            <p className="text-gray-700">
              <span className="font-medium">Phone:</span> {formData.phone}
            </p>
          </div>
          
          <div>
            <p className="text-gray-700">
              <span className="font-medium">Postcode:</span> {formData.postcode}
            </p>
          </div>
          
          {formData.email && (
            <div>
              <p className="text-gray-700">
                <span className="font-medium">Email:</span> {formData.email}
              </p>
            </div>
          )}
        </div>
        
        {formData.issue && (
          <div className="mt-2">
            <p className="text-gray-700">
              <span className="font-medium">Issue:</span> {formData.issue}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserInfo;
